<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  <div class="w-100 mt-3">
    @if (message) {
      <div class="message">{{message}}</div>
    }
    <form [formGroup]="editForm" class="flex-row flex-wrap space-between">
      <mat-form-field appearance="outline" class="w-100 mb-3">
        <input matInput autocomplete="off" formControlName="name" placeholder="Enter Portfolio Name">
        @if (name.errors?.required) {<mat-error>Name is required</mat-error>}
        @if (name.hasError('maxLength')) {<mat-error>Maximum length is 256 characters</mat-error>}
      </mat-form-field>
      @if (portfolioNameExists) {<mat-error>Name is already in use</mat-error>}
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row space-between items-center mt-3">
    <button [disabled]="!canSubmit" mat-flat-button class="w-33" color="primary" (click)="onConfirmClick()" tabindex="2" >{{confirmButtonText}}</button>
    <button [disabled]="!canCancel" class="w-33" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

